export const StringItemsType = Object.freeze({
    PAQUETE: "PAQUETE",
    SALIDA: "SALIDA",
    EXTRA: "EXTRA",
    PLAZAI: "PLAZAI",
    PLAZAM: "PLAZAM",
    PLAZA: "PLAZA"
})